<section
  class="signature-box"
  [ngStyle]="style"
  [ngClass]="{ 'signature-disabled': isLocked, singpass: singpassMode, 'is-signed': isSigned }"
>
  <ng-container *ngIf="!signatureData">
    <div class="signature-box-label">
      {{ info.name }}
    </div>
    <span> Click to Sign</span>
  </ng-container>
  <div
    [innerHTML]="this.signatureData.signature ?? '' | safeSrcHtml"
    class="signature-wrapper"
    #signatureEl
    *ngIf="signatureData"
  ></div>
  <!--            <ng-container *ngIf="currentSigningType==='drawSignature'">-->
  <!--                <img clasFs="signature-img" [src]="signatureData"/>-->
  <!--                <div class="signer-name"><span>{{detail.name}}</span></div>-->
  <!--                <div class="sign-date"><span>{{signedAt | datetime:signedAtFormat}}</span></div>-->
  <!--            </ng-container>-->
  <!--            <ng-container *ngIf="currentSigningType ==='singpass'">-->
  <!--                <div class="signature-singpass">-->
  <!--                    <img class="singpass-watermark" src="../../../../assets/images/icons/singpass-watermark.svg"/>-->
  <!--                    <div class="singpass-info">-->
  <!--                        <div class="by-singpass">Digitally signed by-->
  <!--                            <img src="../../../../assets/images/icons/singpass-logo.svg"/>-->
  <!--                        </div>-->
  <!--                        <div class="timestamp">-->
  <!--                            {{detail.name}}<br>{{signedAt | datetime:signedAtFormat}}-->
  <!--                        </div>-->
  <!--                    </div>-->
  <!--                </div>-->
  <!--            </ng-container>-->
  <!--        </div>-->
</section>
